import PublicNav from './PublicNav';
import PublicFooter from './PublicFooter';

export default function LegalPageLayout({ eyebrow, title, updated, sections }) {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4rem 5% 2rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#00C896', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>{eyebrow}</div>
        <h1 style={{ fontSize: 'clamp(1.7rem,3.2vw,2.3rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', marginBottom: '0.6rem' }}>
          {title}
        </h1>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-3)' }}>Last updated: {updated}</p>
      </section>

      <section style={{ padding: '0 5% 5rem' }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          {sections.map(({ heading, body }) => (
            <div key={heading} style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.05rem', fontWeight: 700, marginBottom: '0.6rem' }}>{heading}</h2>
              <p style={{ fontSize: '0.88rem', color: 'var(--text-2)', lineHeight: 1.75, whiteSpace: 'pre-line' }}>{body}</p>
            </div>
          ))}
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
